import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Styles from './styles';

import { IBreadcrumbs1 } from './params';
import { IBreadcrumb } from '../index';
import { breadcrumbs } from '../../../translates';

const Breadcrumbs: FC<{ items: IBreadcrumb[]; language: string; config: IBreadcrumbs1 }> = ({
  items,
  config,
  language,
}) => {
  const data = [{ label: breadcrumbs[language].home, link: '/' }, ...items];

  return (
    <Styles $config={config}>
      <section className="breadcrumbs">
        <div className="breadcrumbs-container container">
          <div className="breadcrumbs-items">
            {data &&
              data.map((item, index) => (
                <React.Fragment key={index}>
                  {index !== data.length - 1 ? (
                    <>
                      <a href={item.link || '/'} className="breadcrumbs-item">
                        {item.label}
                      </a>
                      <div className="breadcrumbs-item">
                        <FontAwesomeIcon icon={faChevronRight} />
                      </div>
                    </>
                  ) : (
                    <div className="breadcrumbs-item last">{item.label}</div>
                  )}
                </React.Fragment>
              ))}
          </div>
        </div>
      </section>
    </Styles>
  );
};

export default Breadcrumbs;
